import { GlobalStyles } from '@zeus/shared';
import { AboutVariantProps } from '../About/types';
import { CallToActionVariantOneProps } from '../CallToAction/VariantOne/CallToActionVariantOne.types';
import { CateringFormProps } from '../CateringForm/types';
import {
  ButtonVariant,
  ContentPosition,
  HEADER_STATE,
  // ImageCornerVariant,
  MediaType,
  SECTION_HEIGHT,
  RadiusEnum,
} from '../Commons';
import { CustomSectionProps } from '../CustomSection/CustomSection.types';
import { DealsVariantOneProps } from '../Deals/VariantOne/DealsVariantOne.types';
import { FooterVariantProps } from '../Footer/types/index';
import { FormProps } from '../Form/types/Form.types';
import { GiftCardsProps } from '../GiftCards/GiftCard.types';
import { HeaderProps } from '../Header/types';
import { HeroVariantOneProps } from '../Hero/types/index';
import { HowItWorksVariantProps } from '../HowItWorks/VariantOne/works.types';
import { ImageGalleryProps } from '../ImageGallery/types/index';
import { LocationVariantProps } from '../Location/types/LocationVariant.types';
import { MenuProps } from '../SharedComponents/Menu/menu.types';
import { SpotlightsVariantProps } from '../Spotlights/SpotlightsVariant.types';
import { TierProps } from '../Tiers/types/tiers.types';

import IMAGE_PLACEHOLDER from '../../icons/Images/Placeholders/ImagePlaceholders/imagePlaceholder.png';
import { LoyaltyFormProps } from '../LoyalityForm/types/LoyaltyForm.types';
import { InfoCardsProps } from '../InfoCards/InfoCards.types';
import { TestimonialsVariantOneProps } from '../Testimonials/types';
import { AccessibilityProps } from '../Accessibility/Accessibility.types';

const builderConfig = {
  isBuilderDesktopMode: true,
  logoConfig: {
    header: {
      primary: {
        image: 'https://placehold.co/175x70',
        link: '/',
        id: 4,
        altText: '',
        name: '',
      },
      secondary: {
        image: 'https://i.ibb.co/VjscZPk/vibrant-stylized-illustration-bird-flight-1272475-9242.png',
        link: '/',
        id: 4,
        altText: '',
        name: '',
      },
    },
    footer: {
      primary: {
        image: 'https://placehold.co/175x70',
        link: '/',
        id: 4,
        altText: '',
        name: '',
      },
    },
  },
  headerState: HEADER_STATE.SCROLL_UP,
  navLinks: [],
  pageUrls: {},
  builderMode: false,
  previewMode: false,
  componentOrderNumber: 0,
  altText: '',
  name: '',
  onBoarding: {
    address: '',
    phoneNo: '',
    longitude: 0,
    latitude: 0,
    email: '',
    schedule: {
      toggle: false,
      days: null,
    },
  },
  socials: {
    toggle: true,
    icons: {
      facebook: {
        toggle: true,
        link: '',
      },
      instagram: {
        toggle: true,
        link: '',
      },
      twitter: {
        toggle: true,
        link: '',
      },
      yelp: {
        toggle: true,
        link: '',
      },
      youtube: {
        toggle: true,
        link: '',
      },
      tiktok: {
        toggle: true,
        link: '',
      },
      google: {
        toggle: true,
        link: '',
      },
    },
  },
  builderConfigData: {
    restaurantId: '1',
    businessId: '1',
    environmentUrl: '',
    onlineOrderingUrl: '',
    businessAlias: '',
    restaurantAlias: '',
    websiteId: '',
    pageName: '',
  },
  slug: '',
  colors: {
    primary: null,
    secondary: null,
    tertiary: null,
  },
  contentPosition: ContentPosition.RIGHT,
  shouldUsePrimaryHeading: false,
};

const globalStyles: GlobalStyles = {
  button: {},
  heading: {},
  subHeading: {},
  bodyText: {},
  backgroundColor: '',
  buttonVariants: {
    primary: {},
    secondary: {},
    tertiary: {},
  },
  buttonRadius: 0,
  imageRadius: {
    radius: RadiusEnum.SHARP,
    value: 0,
  },
  cardRadius: {
    radius: RadiusEnum.SHARP,
    value: 0,
  },
  headerState: HEADER_STATE.SCROLL_UP,
  // selectedBorderRadius: ButtonCornerVariant.SOFT_CORNERS,
  // selectedImageBorder: ImageCornerVariant.SHARP_CORNERS,
};

// this is just initial dummy function to set data
const setComponentData = (key: string, value: string) => {
  return;
};

export const headerInitialProps: HeaderProps = {
  componentConfig: {
    button: {
      toggle: false,
      internal: true,
      label: 'Online ordering',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    navLinks: {
      toggle: true,
    },
    logoToggle: false,
    allCapsToggle: false,
    background: {
      value: '',
      type: 'color' as const,
      blur: 5,
    },
  },

  builderConfig,
  globalStyles,
  localStyles: {
    button: {},
    navbarLinkStyles: {},
    selectedNavLinkColor: '',
    selectedNavLinkBackgroundColor: '',
    backgroundColor: '',
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const heroVariantOneInitialProps: HeroVariantOneProps = {
  componentConfig: {
    overline: {
      toggle: false,
      text: 'our story',
    },
    heading: {
      toggle: true,
      text: 'Heading',
    },
    subheading: {
      toggle: false,
      text: 'Sub heading',
    },
    bodyText: {
      toggle: false,
      text: 'Description',
    },
    button: {
      toggle: false,
      internal: true,
      label: 'Click here',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    secondaryButton: {
      toggle: false,
      internal: true,
      label: 'Click here',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.SECONDARY,
      },
    },
    image: {
      toggle: true,
      value: 'https://placehold.co/1920x800',
      altText: '',
      name: '',
      loading: false,
    },
    video: {
      toggle: true,
      value: '',
      placeholder: '',
    },
    carousel: {
      toggle: true,
      value: [],
      type: 'carousel' as const,
    },
    secondaryImage: {
      toggle: true,
      value: 'https://placehold.co/1920x800',
      altText: '',
      name: '',
      loading: false,
    },
    overlayStyles: {
      toggle: true,
      overlayColor: '#000000',
      overlayOpacity: 0.01,
      blurValue: 0.01,
    },
    sectionHeight: SECTION_HEIGHT.DEFAULT,
    customHeight: 0,
    variant: 'STILL_IMAGE' as const,
    contentPosition: ContentPosition.CENTER,
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    overline: {},
    subheading: {},
    button: {},
    bodyText: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const aboutVariantInitialProps: AboutVariantProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Title',
    },
    subheading: {
      toggle: true,
      text: 'Description',
    },
    image: {
      toggle: true,
      value: 'https://placehold.co/600',
      altText: '',
      name: '',
      loading: false,
    },
    overline: {
      toggle: true,
      text: 'Our Story',
    },
    video: {
      toggle: true,
      value: '',
      placeholder: '',
    },
    button: {
      toggle: true,
      internal: true,
      label: 'Click here',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    secondaryButton: {
      toggle: false,
      internal: true,
      label: 'Click here',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.SECONDARY,
      },
    },
    bodyText: {
      toggle: true,
      text: `Lorem Ipsum dolor sit amet, consectetur adipiscing elit sed diam nonum et justo ut aliquet consequ et dolore magna aliquet consequ dummy magna aliquet consequ`,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
      blurValue: 0,
      mediaType: 'STILL_IMAGE' as const,
    },
    backgroundVideo: {
      toggle: true,
      value: '',
      placeholder: '',
    },
    mediaConfig: {
      mediaType: MediaType.IMAGE,
      toggle: true,
    },
    contentPosition: ContentPosition.RIGHT,
    sectionHeight: SECTION_HEIGHT.DEFAULT,
    multiContent: {
      toggle: true,
      values: [],
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subheading: {},
    bodyText: {},
    button: {},
    overline: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const locationInitialProps: LocationVariantProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'OPENING HOURS',
    },
    subHeading: {
      toggle: true,
      text: 'Sub heading',
    },
    bodyText: {
      toggle: false,
      text: 'Description',
    },
    address: {
      toggle: false,
    },
    map: {
      toggle: true,
      height: 400,
      theme: 'light',
      disableLabels: true,
    },
    openTable: {
      toggle: false,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
      blurValue: 0,
      mediaType: 'STILL_IMAGE' as const,
    },
    backgroundVideo: {
      toggle: true,
      value: '',
      placeholder: '',
    },
    secondaryColor: {
      value: '',
      type: 'color' as const,
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    bodyText: {},
    address: {},
    addressHeading: {},
    serviceHoursText: {},
    mapPopupBackground: {
      color: '#000000',
    },
    mapPopupText: {
      color: '#000000',
    },
    serviceHoursHeading: {},
  },
  setComponentData,
};

export const footerInitialProps: FooterVariantProps = {
  componentConfig: {
    footerLogo: {
      toggle: true,
    },
    contactTitle: {
      toggle: true,
      text: 'Contact Us',
    },
    hoursTitle: {
      toggle: true,
      text: 'Service Hours',
    },
    navLinks: {
      toggle: true,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    address: {
      toggle: true,
      text: 'Lore ipsum dolor sit amet, consectetur adipiscing elit',
    },
    phone: {
      toggle: true,
      text: '(111) 111-1111',
    },
    email: {
      toggle: true,
      text: 'user@example.com',
    },
    sectionHeight: SECTION_HEIGHT.DEFAULT,
    customHeight: 400,
  },
  builderConfig,
  globalStyles,
  localStyles: {
    title: {},
    brandInfo: {},
    poweredBy: {},
    icons: {},
  },
  setComponentData,
};

export const imageGalleryInitialProps: ImageGalleryProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Title',
    },
    subHeading: {
      toggle: false,
      text: 'Sub Heading',
    },
    description: {
      toggle: true,
      text: 'Description',
    },
    images: {
      toggle: true,
      values: [
        {
          fileUrl: IMAGE_PLACEHOLDER as unknown as string,
          id: 1,
          isPlaceholder: true,
          altText: 'Alt text of image here',
          loading: false,
          type: 'image/jpeg',
        },
        {
          fileUrl: IMAGE_PLACEHOLDER as unknown as string,
          id: 2,
          isPlaceholder: true,
          altText: 'Alt text of image here',
          loading: false,
          type: 'image/jpeg',
        },
        {
          fileUrl: IMAGE_PLACEHOLDER as unknown as string,
          id: 3,
          isPlaceholder: true,
          altText: 'Alt text of image here',
          loading: false,
          type: 'image/jpeg',
        },
        {
          fileUrl: IMAGE_PLACEHOLDER as unknown as string,
          id: 4,
          isPlaceholder: true,
          altText: 'Alt text of image here',
          loading: false,
          type: 'image/jpeg',
        },
        {
          fileUrl: IMAGE_PLACEHOLDER as unknown as string,
          id: 5,
          isPlaceholder: true,
          altText: 'Alt text of image here',
          loading: false,
          type: 'image/jpeg',
        },
        {
          fileUrl: IMAGE_PLACEHOLDER as unknown as string,
          id: 6,
          isPlaceholder: true,
          altText: 'Alt text of image here',
          loading: false,
          type: 'image/jpeg',
        },
      ],
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    description: {},
  },
  setComponentData,
};

export const featuredMenuInitialProps: MenuProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Title',
    },
    subHeading: {
      toggle: false,
      text: 'sub heading',
    },
    description: {
      toggle: true,
      text: 'Description',
    },
    menu: {
      toggle: true,
      descriptionToggle: true,
      imageToggle: true,
      priceToggle: true,
      ids: [],
    },
    image: {
      aspectRatio: '1/1',
      imageFit: 'scale',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    contentPosition: ContentPosition.RIGHT,
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    menuItemBackground: {
      value: '',
      type: 'color' as const,
    },
    menuContentBackground: {
      value: '#D3D3D3',
      type: 'color' as const,
    },
    itemBorderWeight: {
      value: 1,
    },
    button: {
      toggle: true,
      internal: true,
      label: 'button text',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    itemPopup: {
      image: true,
      name: true,
      price: true,
      description: true,
      modifiers: true,
      buttons: true,
      tagsAndAllergens: true,
    },

    categoryHeading: { toggle: false },
    subCategoryHeading: { toggle: false },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    description: {},
    button: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
    menuItemTitle: {},
    menuItemDescription: {},
    menuItemPrice: {},
    itemCardBorder: {},
    bottomContainer: {},
    itemImageBackgroundColor: {},
    selectedItemBackgroundColor: {},
    categoryHeading: {},
    subCategoryHeading: {},
    itemPopup: {
      name: {},
      price: {},
      description: {},
      modifiers: {},
      backgroundColor: '#FFFFFF',
    },
  },
  setComponentData,
};

export const menuInitialProps: MenuProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Menu',
    },
    subHeading: {
      toggle: false,
      text: 'sub heading',
    },
    description: {
      toggle: false,
      text: 'Menu Description',
    },
    menu: featuredMenuInitialProps.componentConfig.menu,
    background: featuredMenuInitialProps.componentConfig.background,
    backgroundImage: featuredMenuInitialProps.componentConfig.backgroundImage,
    menuItemBackground: featuredMenuInitialProps.componentConfig.menuItemBackground,
    menuContentBackground: featuredMenuInitialProps.componentConfig.menuContentBackground,
    button: featuredMenuInitialProps.componentConfig.button,
    categoryHeading: { toggle: true },
    subCategoryHeading: { toggle: true },
    menuGrid: 3,
    menuNav: 'topbar',
    categoryTiles: {
      value: '#888D95',
      type: 'color',
    },
    itemPopup: {
      image: true,
      name: true,
      price: true,
      description: true,
      modifiers: true,
      buttons: true,
      tagsAndAllergens: true,
    },
  },

  builderConfig,
  globalStyles,
  localStyles: {
    ...featuredMenuInitialProps.localStyles,
    categoryHeading: {},
    subCategoryHeading: {},
    menuName: {},
    itemPopup: {
      name: {},
      price: {},
      description: {},
      modifiers: {},
      backgroundColor: '#FFFFFF',
    },
  },
  setComponentData,
};

export const tiersInitialProps: TierProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Loyalty & Tier Points',
    },
    subHeading: {
      toggle: false,
      text: 'sub heading',
    },
    description: {
      toggle: false,
      text: 'Tier Points Description',
    },
    menu: featuredMenuInitialProps.componentConfig.menu,
    background: featuredMenuInitialProps.componentConfig.background,
    backgroundImage: featuredMenuInitialProps.componentConfig.backgroundImage,
    menuItemBackground: featuredMenuInitialProps.componentConfig.menuItemBackground,
    menuContentBackground: featuredMenuInitialProps.componentConfig.menuContentBackground,
    button: featuredMenuInitialProps.componentConfig.button,
  },
  builderConfig,
  globalStyles,
  localStyles: { ...featuredMenuInitialProps.localStyles },
  setComponentData,
};

export const dealsVariantOneInitialProps: DealsVariantOneProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Deals Title',
    },
    subHeading: {
      toggle: false,
      text: 'sub heaeding',
    },
    description: {
      toggle: true,
      text: 'Deals Description',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    dealItemBackground: {
      value: '',
      type: 'color' as const,
    },
    button: {
      toggle: true,
      internal: true,
      label: 'View all deals',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    deals: {
      toggle: true,
      typeToggle: true,
      descriptionToggle: true,
      availabilityToggle: true,
      imageToggle: true,
      ids: [],
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    description: {},
    button: {},
    dealItemName: {
      fontSize: '28px',
      fontWeight: '500',
      lineHeight: '42px',
      letterSpacing: '0px',
    },
    dealItemDescription: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '16px',
      letterSpacing: '0px',
    },
    dealItemAvailability: {
      fontSize: '18px',
      fontWeight: '500',
      lineHeight: '27px',
      letterSpacing: '0px',
    },
    dealItemType: {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '16px',
      letterSpacing: '0px',
    },
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const spotlightsInitialProps: SpotlightsVariantProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Spotlights Title',
    },
    subHeading: {
      toggle: false,
      text: 'Spotlights sub heading',
    },
    description: {
      toggle: true,
      text: 'Spotlights Description',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    cardBackground: {
      toggle: false,
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    spotlightItemName: {
      toggle: true,
    },
    spotlightItemDescription: {
      toggle: true,
    },
    spotlightItemImage: {
      toggle: true,
    },
    spotlightButton: {
      toggle: true,
      internal: false,
      label: 'View spotlight',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    spotlights: {
      toggle: true,
      descriptionToggle: true,
      headingToggle: true,
      imageToggle: true,
      buttonToggle: true,
      ids: [],
      perIndex: {},
    },
    sectionHeight: SECTION_HEIGHT.DEFAULT,
    customHeight: 400,
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    description: {},
    button: {},
    spotlightItemName: {
      fontSize: '20px',
      fontWeight: '500',
      lineHeight: '36px',
      letterSpacing: '0px',
    },
    spotlightItemDescription: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '21px',
      letterSpacing: '0px',
    },
    spotlightButton: {},
    spotlightItemImage: {},
    spotlights: {
      perIndex: {},
    },
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const announcementPopupInitialProps = {
  announcementData: {
    name: 'The wait is over',
    description: 'Our restaurant is live now in the heart of Vegas. Order now.',
    type: 'We are here with a BANGER!',
    link: 'https://www.google.com',
    image: 'https://via.placeholder.com/150',
  } as any,
  viewMode: false,
  restaurantId: builderConfig.builderConfigData.restaurantId,
  businessId: builderConfig.builderConfigData.businessId,
  environmentUrl: builderConfig.builderConfigData.environmentUrl,
  builderMode: builderConfig.builderMode,
  previewMode: builderConfig.previewMode,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handlePopupClose: () => {},
  globalStyles,
};

export const customSectionInitialProps: CustomSectionProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Title',
    },
    description: {
      toggle: true,
      text: 'Description',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    defaultContainer: true,
    htmlContent: `<div id=test>Custom HTML content goes here</div>`,
    cssContent: `#test { color: red }`,
    jsContent: `console.log("Custom JS runs here");`,
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
  },
  setComponentData,
};

export const callToActionVariantOneInitialProps: CallToActionVariantOneProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Start earning endless rewards and amazing discounts.',
    },
    subheading: {
      toggle: false,
      text: 'Sub heading',
    },
    button: {
      toggle: true,
      internal: true,
      label: 'Sign Up',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    secondaryButton: {
      toggle: false,
      internal: true,
      label: 'Sign Up',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.SECONDARY,
      },
    },
    bodyText: {
      toggle: false,
      text: `Lorem Ipsum dolor sit amet, consectetur adipiscing elit sed diam nonum et justo ut aliquet consequ et dolore magna aliquet consequ dummy magna aliquet consequ`,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    image: {
      toggle: false,
      value: 'https://i.ibb.co/VjscZPk/vibrant-stylized-illustration-bird-flight-1272475-9242.png',
      altText: '',
      name: '',
      loading: false,
    },
    openTable: {
      toggle: false,
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subheading: {},
    bodyText: {},
    button: {},
    secondaryButton: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const accessibilityInitialProps: AccessibilityProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Website accessibility',
    },
    bodyText: {
      toggle: true,
      text: `At AIO, we’re committed to making our website easy for everyone to use, including people with disabilities. We want all visitors to have a smooth and accessible experience when exploring our site. If you have trouble accessing any part of our website or need help using our online materials or services, please reach out to us at [enter email]. Be sure to include the page URL and a brief description of the problem so we can look into it right away. We truly value your feedback, it helps us improve and make our website better for everyone. While we don’t control the content of third-party sites or vendors, we encourage all our partners to make their materials accessible and user-friendly as well.`,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    bodyText: {},
  },
  setComponentData,
};

export const howItWorksInitialProps: HowItWorksVariantProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'How it Works?',
    },
    subHeading: {
      toggle: true,
      text: '$1 = 100 loyalty points',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    stepTitle: {},
    stepDescription: {},
    icon: {},
  },
  setComponentData,
};

export const giftCardsInitialProps: GiftCardsProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Gift card',
    },
    subheading: {
      toggle: true,
      text: "Whether you're celebrating a birthday, anniversary or the holidays, gift card is the perfect way to show appreciation to your loved ones",
    },
    description: {
      toggle: false,
      text: 'Lorem Ipsum dolor sit amet, consectetur adipiscing elit sed diam nonum et justo ut aliquet consequ et dolore magna aliquet consequ dummy magna aliquet consequ',
    },
    button: {
      toggle: true,
      internal: true,
      label: 'Check balance',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    giftCards: {
      ids: [],
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subheading: {},
    description: {},
    button: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const loyaltyFormInitialProps: LoyaltyFormProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Form',
    },
    subheading: {
      toggle: true,
      text: 'Lorem Ipsum dolor sit amet, consectetu',
    },
    button: {
      label: 'Submit',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    bodyText: {
      toggle: false,
      text: `Lorem Ipsum dolor sit amet, consectetur adipiscing elit sed diam nonum et justo ut aliquet consequ et dolore magna aliquet consequ dummy magna aliquet consequ`,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    image: {
      toggle: true,
      value: 'https://placehold.co/600',
      altText: '',
      name: '',
      loading: false,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    form: {
      recipientEmails: [],
      confirmationMessage: 'Form Submitted successfully',
    },
    contentPosition: ContentPosition.LEFT,
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subheading: {},
    bodyText: {},
    button: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const formInitialProps: FormProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Form',
    },
    subheading: {
      toggle: true,
      text: 'Lorem Ipsum dolor sit amet, consectetu',
    },
    button: {
      label: 'Submit',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
    bodyText: {
      toggle: false,
      text: `Lorem Ipsum dolor sit amet, consectetur adipiscing elit sed diam nonum et justo ut aliquet consequ et dolore magna aliquet consequ dummy magna aliquet consequ`,
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    image: {
      toggle: true,
      value: 'https://placehold.co/600',
      altText: '',
      name: '',
      loading: false,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    template: null,
    form: {
      formId: null,
      fieldsOrder: [],
      settings: {
        formLabel: 'Form',
        recipientEmails: [],
        confirmationMessage: 'Form Submitted successfully',
      },
    },
    contentPosition: ContentPosition.LEFT,
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subheading: {},
    bodyText: {},
    button: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};

export const cateringFormInitialProps: CateringFormProps = formInitialProps;
export const infoCardsInitialProps: InfoCardsProps = {
  componentConfig: {
    heading: {
      toggle: false,
      text: 'Info Cards',
    },
    subHeading: {
      toggle: false,
      text: 'Sub heading',
    },
    description: {
      toggle: false,
      text: 'Description',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    cardsBackground: {
      value: '#F5F5F5',
      type: 'color' as const,
    },
    cards: {
      toggle: true,
      items: [],
    },
    cardOverline: { toggle: true },
    cardHeading: { toggle: true },
    cardSubheading: { toggle: true },
    cardDescription: { toggle: true },
    layout: {
      type: 'single',
      alignment: 'center',
      cardAlignment: 'left',
      cornerRadius: 0,
    },
    buttons: {
      toggle: true,
      primary: {
        toggle: true,
        internal: true,
        label: 'Primary Button',
        link: '',
        pageId: '',
        sectionId: '',
        variant: {
          type: 'radio' as const,
          value: ButtonVariant.PRIMARY,
        },
      },
      secondary: {
        toggle: true,
        internal: true,
        label: 'Secondary Button',
        link: '',
        pageId: '',
        sectionId: '',
        variant: {
          type: 'radio' as const,
          value: ButtonVariant.SECONDARY,
        },
      },
      buttonVariants: {
        [ButtonVariant.PRIMARY]: {},
        [ButtonVariant.SECONDARY]: {},
        [ButtonVariant.TERTIARY]: {},
      },
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    description: {},
    cardHeading: {},
    cardSubheading: {},
    cardDescription: {},
    cardOverline: {},
    cardsBackground: {
      color: '',
    },
    dashedBorderColor: '',
    cards: {
      items: [],
    },
    buttons: {
      primary: {},
      secondary: {},
    },
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
  },
  setComponentData,
};
export const testimonialsVariantOneInitialProps: TestimonialsVariantOneProps = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Customer testimonials title',
    },
    subheading: {
      toggle: true,
      text: 'What our customers are saying',
    },

    testimonials: {
      toggle: true,
      values: [],
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    autoScroll: {
      toggle: false,
      speed: 1,
    },
    starRating: {
      toggle: true,
    },
    customerName: {
      toggle: true,
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    customerName: {},
    review: {},
    cardBackground: {
      backgroundColor: '#f9f9f9',
    },
    focusedCardBackground: {
      backgroundColor: '#ffffff',
    },
    starRating: {
      color: '#FFB800',
    },
  },
  setComponentData,
};

export const packagesVariantOneInitialProps: any = {
  componentConfig: {
    heading: {
      toggle: true,
      text: 'Packages',
    },
    subHeading: {
      toggle: false,
      text: 'Our Packages',
    },
    description: {
      toggle: false,
      text: 'Choose from our exclusive packages.',
    },
    tabs: {
      toggle: true,
      text: 'Categories',
    },
    background: {
      value: '',
      type: 'color' as const,
    },
    backgroundImage: {
      toggle: false,
      value: '',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
    },
    button: {
      toggle: true,
      internal: true,
      label: 'Order online',
      link: '',
      pageId: '',
      sectionId: '',
      variant: {
        type: 'radio' as const,
        value: ButtonVariant.PRIMARY,
      },
    },
  },
  builderConfig,
  globalStyles,
  localStyles: {
    heading: {},
    subHeading: {},
    description: {},
    button: {},
    buttonVariants: {
      [ButtonVariant.PRIMARY]: {},
      [ButtonVariant.SECONDARY]: {},
      [ButtonVariant.TERTIARY]: {},
    },
    cardBackground: {},
    cardBorder: {},
    packageName: {},
    packageDescription: {},
    packageLabel: {},
    packageLabelText: {},
    packageAttributes: {},
    attributeBodyText: {},
    callToActionText: {},
    packageCategories: {},
    selectedTab: {},
    defaultTab: {},
    icon: {},
  },
  setComponentData,
};
